export const chatTypes = {
    getChat: '[CHAT] Get chat',
    setChat: '[CHAT] set chat users',
    resetChat: '[CHAT] Reset',
    setChatConnection: '[CHAT] status connection',
    setCountMsg: '[CHAT] count messages',
    setCountChats: '[CHAT] count chats',
    setActiveChat: '[CHAT] chat active to chat'
}